import React from "react";
import ct from "class-types.macro";
import Icon from "~/common/Icons/Standard";

export interface Props {
  name: string | number;
  listItemClasses: string;
  linkClasses: string;
  targetPage: number;
  totalPages: number;
  ariaLabel: string;
  icon?: string;
  createHREF?: (page: number) => string;
  onChange?: ((page: number, pageSize: number) => void) | undefined;
}

const PaginationItem = ({
  name,
  listItemClasses,
  linkClasses,
  targetPage,
  totalPages,
  ariaLabel,
  icon,
  createHREF,
  onChange,
}: Props) => {
  const onChangeFunc = (
    e: React.SyntheticEvent<HTMLAnchorElement, MouseEvent>,
    page: number
  ) => {
    e.preventDefault();
    if (onChange) {
      onChange(page, totalPages);
    }
  };

  return (
    <li className={listItemClasses}>
      <a
        aria-label={ariaLabel}
        href={createHREF ? createHREF(targetPage) : "#"}
        onClick={onChange ? (e) => onChangeFunc(e, targetPage) : undefined}
        className={`${linkClasses} pagerLink`}
      >
        {icon ? <Icon name={icon} className={ct("h-3", "w-3")} /> : name}
      </a>
    </li>
  );
};

export default PaginationItem;
